var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',_vm._g(_vm._b({class:{'gj-button--icon': _vm.type === 'icon',
     'gj-button--font14': _vm.font14,
     'gj-button--ghost': _vm.type === 'ghost',
     'gj-btn-iconfont': _vm.type === 'iconfont'
     },attrs:{"size":_vm.btnSize,"type":_vm.type},on:{"click":_vm.clickEvent}},'el-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),(_vm.iconfont && (_vm.type === 'iconfont'))?_c('i',{staticClass:"iconfont",class:_vm.iconfont,style:({'font-size': _vm.btnSize})}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }